const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class ReverseGeocoderServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async getReverseGeocode(options = {}, overrides = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/geo/geocoder/reverse`,
        method: 'GET',
        ...options,
      };

      if (overrides.baseURL) {
        request.baseURL = overrides.baseURL;
      }

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  ReverseGeocoderServiceConnector,
};
